module.exports = __webpack_public_path__ + "img/CVC.0fd73061.svg";